import React, { useState } from 'react';
import { Form } from 'antd';
import { useModal } from '../../../contexts/modalsContext/modalsContext';
import { useAuth } from '../../../contexts/userContext/userContext';
import { loginCustomer } from '../../../../services/login/Login.api';
import AuthDrawer from '../drawers/authDrawer/AuthDrawer';
import AuthorizeModal from '../modals/authorizeModal/AuthorizeModal';

function Authorization() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { setShowAuthModal, setShowRegisterModal } = useModal();
  const { setUser } = useAuth();

  const handleSubmit = async (values) => {
    try {
      setErrors(null);
      setLoading(true);
      const res = await loginCustomer(values);
      if (res.status === 'success') {
        setUser({}, res.token);
        setTimeout(() => {
          setLoading(false);
          setShowAuthModal(false);
        }, 50);
      }
    } catch (e) {
      setLoading(false);
      setErrors(e?.response?.data?.errors);
    }
  };

  const handleNotRegistered = () => {
    setShowAuthModal(false);
    setTimeout(() => setShowRegisterModal(true), 100);
  };
  return (
    <>
      <AuthDrawer
        loading={loading}
        errors={errors}
        form={form}
        handleSubmit={handleSubmit}
        handleNotRegistered={handleNotRegistered}
      />
      <AuthorizeModal
        loading={loading}
        errors={errors}
        form={form}
        handleSubmit={handleSubmit}
        handleNotRegistered={handleNotRegistered}
      />
    </>
  );
}

export default Authorization;
